import Theme from '../../constants/Theme'

export default {
  colors: {
    primary: Theme.colors.primary,
    brightPrimary: Theme.colors.brightPrimary,
    accent: Theme.colors.accent,
    appBackground: Theme.colors.appBackground,
    background: Theme.colors.background,
    text: Theme.colors.text,
    placeholderText: Theme.colors.placeholderText,
    border: Theme.colors.border,
    attention: Theme.colors.attention,
    enabled: Theme.colors.enabled,
    disabled: Theme.colors.disabled
  },
  space: Theme.space,
  sizes: Theme.sizes,
  fontSizes: Theme.fontSizes,
  fontWeights: {
    thin: Theme.fontWeights.thin,
    light: Theme.fontWeights.light,
    regular: Theme.fontWeights.regular,
    medium: Theme.fontWeights.medium,
    bold: Theme.fontWeights.bold,
    black: Theme.fontWeights.black
  }
}
